/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Record Service API
 * OpenAPI spec version: 1.0.0
 */

export type FilterFieldConditionOp =
  (typeof FilterFieldConditionOp)[keyof typeof FilterFieldConditionOp];

export const FilterFieldConditionOp = {
  eq: "eq",
  in: "in",
  and: "and",
  contains: "contains",
  or: "or",
  gte: "gte",
  lte: "lte",
  exists: "exists",
  ne: "ne",
  notContains: "notContains",
  startsWith: "startsWith",
  endsWith: "endsWith",
  gt: "gt",
  lt: "lt",
  notIn: "notIn",
} as const;
